import {filterFeaturesByValues} from "../../../FeatureCreator/FeaturesFilters/filtersFunctions";
import {AVAILABLE_VISUALIZERS} from "../../../../constants/dashboard";

export const getWizardPopupFeatures = (enabledFeatures, wizardVisualizer) => {
  switch (wizardVisualizer) {
    case AVAILABLE_VISUALIZERS.bathroom:
      return enabledFeatures.filter(feat => feat.hasBathroom || feat.toolSettings.some(x => x.tool === "bathroom"))
    case AVAILABLE_VISUALIZERS.kitchen:
      return enabledFeatures.filter(feat => feat.hasKitchen || feat.toolSettings.some(x => x.tool === "kitchen"))
    case AVAILABLE_VISUALIZERS.fireplace:
      return enabledFeatures.filter(feat => feat.hasFireplace || feat.toolSettings.some(x => x.tool === "fireplace"))
    // case AVAILABLE_VISUALIZERS.leadform:
    //   todo to change
      // return enabledFeatures.filter(feat => feat.hasBathroom || feat.toolSettings.some(x => x.tool === "bathroom"))
    default:
      return enabledFeatures
  }
}

/**
 * returns current wizard step section items
 * @param features {array}
 * @param searchText {string}
 * @param selectedFilters {array}
 * @returns array {[featureInterface]}
 */
export const filterWizardPopupFeatures = (features = [], searchText = "", selectedFilters) => {
  if (searchText) {
    const lowerCasedSearch = searchText.toLowerCase();
    features = features.filter(feature => (feature.name || "").toLowerCase().includes(lowerCasedSearch)
      || (feature.sku || "").toLowerCase().includes(lowerCasedSearch))
  }
  if (selectedFilters.length) {
    features = filterFeaturesByValues(features, selectedFilters);
  }
  return features
}
